import { useState, useEffect } from 'react';

type useMediaQueryReturn<T> = T extends number ? [boolean, number] : [number];

const getScreenWidth = (screen: string) => {
  switch (screen) {
    case 'sm':
      return 743;
    case 'md':
      return 1024;
    case 'lg':
      return 1368;
    case 'xs':
      return 360;
    default:
      return 0;
  }
};

//custom hook that returns if current screen width is larger than
//the width breakpoint argument or not
const useMediaQuery = <T>(breakpoint?: T, ssrScreenSize?: any) => {
  //current width
  const [width, setWidth] = useState(ssrScreenSize && ssrScreenSize !== undefined ? getScreenWidth(ssrScreenSize) : 0);

  //function to update state with window's screen width
  const updateWidth = () => setWidth(window.innerWidth);

  useEffect(() => {
    updateWidth();
    window.addEventListener('resize', updateWidth);

    //cleanup after unmounting
    return () => window.removeEventListener('resize', updateWidth);
  }, [ssrScreenSize]);

  //return a destructible array that includes the boolean and the width also
  return (breakpoint ? [width >= +breakpoint, width] : [width]) as useMediaQueryReturn<T>;
};

export default useMediaQuery;
